export default "* Hvad tror I fisk spiser?\n* Hvor tror I smådyrene gemmer sig?\n* Hvordan tror I vi nemmest kan fange smådyr i vand?";